function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 54,
  rx: 4,
  fill: "#0A4AB7",
  fillOpacity: 0.04
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3913 18.7858H24.2709C25.5919 18.7858 26.6654 17.7155 26.6654 16.3945C26.6654 15.0735 25.5919 14 24.2709 14H13.3913C12.0703 14 11 15.0735 11 16.3945C11 17.7155 12.0703 18.7858 13.3913 18.7858ZM30.8887 29.5719H13.3913C12.0703 29.5719 11 28.5016 11 27.1806C11 25.8596 12.0703 24.7861 13.3913 24.7861H30.8887C32.2097 24.7861 33.2832 25.8596 33.2832 27.1806C33.2832 28.5016 32.2097 29.5719 30.8887 29.5719ZM40.4539 40.5723H14.5413C12.585 40.5723 11 39.4541 11 38.0739C11 36.6938 12.585 35.5723 14.5413 35.5723H40.4539C42.4102 35.5723 44 36.6938 44 38.0739C44 39.4541 42.4102 40.5723 40.4539 40.5723Z",
  fill: "#055445"
});

function SvgPaperLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperLog);
export default __webpack_public_path__ + "static/media/paperLog.d1157f3b8d6e6004edd0c84110c8f870.svg";
export { ForwardRef as ReactComponent };